<!--
Copyright 2022 Google Inc. All rights reserved.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->
<!-- modified for WISPR-lab/data-export-gui -->
<template>
  <v-menu v-model="showMenu" offset-x :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-icon title="Modify tags" v-if="assignedTags.length > 0" v-bind="attrs" v-on="on" class="ml-1">mdi-tag-plus</v-icon>
      <v-icon title="Modify tags" v-else v-bind="attrs" v-on="on" class="ml-1">mdi-tag-plus-outline</v-icon>
    </template>

    <event-tag-dialog
      :events="[event]"
      :show-propagate-option="showPropagateOption"
      :event-count="eventCount"
      :events-query="eventsQuery"
      :persist="persist"
      :silent="silent"
      @close="showMenu = false"
      @tag-added="$emit('tag-added', $event)"
      @tag-removed="$emit('tag-removed', $event)"
    ></event-tag-dialog>

  </v-menu>
</template>

<script>
import EventTagDialog from './EventTagDialog.vue'

export default {
  components: {
    EventTagDialog
  },
  props: {
    event: {
      type: Object,
      default: () => ({ _source: { tags: [] } })
    },
    showPropagateOption: {
      type: Boolean,
      default: false
    },
    eventCount: {
      type: Number,
      default: 0
    },
    eventsQuery: {
      type: String,
      default: ''
    },
    persist: {
      type: Function,
      default: null
    },
    silent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMenu: false,
    }
  },
  watch: {
    showMenu(val) {
      if (val && this.$store.state.demoMode) {
        const EventBus = require('@/event-bus.js').default
        EventBus.$emit('demo:action', 'tag-menu-opened')
      }
    }
  },
  computed: {
    assignedTags() {
      if (!this.event || !this.event._source || !this.event._source.tags) return []
      return this.event._source.tags
    },
  },
}
</script>

<style scoped lang="scss"></style>
